import React from 'react';
import { HiClipboardCheck, HiClock, HiShieldCheck } from 'react-icons/hi';
import './ValueProps.css';

export default function ValueProps() {
  return (
    <section className="section valueProps anchor" id="value">
      <div className="container">
        <header className="valueProps__header">
          <h2 className="valueProps__title">Why Work With Me?</h2>
          <p className="valueProps__subtitle">
            Clear structure, reliable delivery, and practical IT support so your team moves faster
            with less risk.
          </p>
        </header>

        <div className="valueProps__grid">
          <article className="valueProps__card">
            <div className="valueProps__cardHeader">
              <HiClipboardCheck className="valueProps__cardIcon" />
              <h3>Clarity & Control</h3>
            </div>
            <p>
              Clear scope, owners, and reporting so stakeholders stay aligned and your team knows
              exactly what success looks like.
            </p>
          </article>
          <article className="valueProps__card">
            <div className="valueProps__cardHeader">
              <HiClock className="valueProps__cardIcon" />
              <h3>On-Time Delivery</h3>
            </div>
            <p>
              Strong planning, Agile and Scrum execution, and risk management to protect timelines
              and keep delivery predictable.
            </p>
          </article>
          <article className="valueProps__card">
            <div className="valueProps__cardHeader">
              <HiShieldCheck className="valueProps__cardIcon" />
              <h3>Stable IT Systems</h3>
            </div>
            <p>
              Faster troubleshooting, better incident handling, and ITIL based improvements so you
              reduce downtime and recurring issues.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
